import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;
import "./assets/icons"; // icon

import "./assets/css/common.less";
import "./assets/css/theme/dark.css";
import "./assets/css/theme/light.css";

Vue.config.ignoredElements = ["wx-open-launch-app"];
// import { MessagePlugin } from "tdesign-vue";
// 引入组件库的少量全局样式变量
import "tdesign-vue/es/style/index.css";

// Vue.use(MessagePlugin);
import unityBridge from "./utils/unityBridge";
// main.js
import TDesign from "tdesign-vue";

Vue.use(TDesign);
Vue.prototype.$unity = unityBridge;

import "./utils/rem"; // 引入rem适配

import Aegis from "aegis-web-sdk";

// 假设从某个地方获取用户ID

const aegis = new Aegis({
  id: process.env.VUE_APP_AEGIS_ID,
  uin: "",
  reportApiSpeed: true,
  reportAssetSpeed: true,
  spa: true,
  pagePerformance: true,
  hostUrl: "https://rumt-zh.com",
  api: {
    // 示例：如果你的接口成功码是 '0'，失败是其他值
    // retCodeHandler(data) {
    //   try {
    //     const parsedData = JSON.parse(data);
    //     return {
    //       isErr: parsedData.code !== "0",
    //       code: parsedData.code
    //     };
    //   } catch (e) {
    //     return { isErr: true, code: "parse_error" };
    //   }
    // }
  }
});

Vue.config.errorHandler = function (err, vm, info) {
  aegis.error(
    `Vue Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`
  );
};

// ... 其余Vue初始化代码
let vueDom = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default vueDom;
